import ServiceCategoryPage from '@/components/business/ServiceCategoryPage';
import { makeServiceCategoryPaths, makeServiceCategoryProps } from '@/lib/serviceCategoryFactory';
import { BusinessItem } from '@/core/models/businesses/businessList';
import { GetStaticPaths, GetStaticProps } from 'next';

const CATEGORY_ID = '1778';
const CATEGORY_LABEL = 'Licence Renewals';
const CATEGORY_SLUG = 'licence-renewals';
const CATEGORY_DESCRIPTION = 'Find vehicle licence renewal services near you. Get assistance renewing your motor vehicle licence disc quickly and easily.';
const TAGS: string[] = ['Licence Disc', 'Renewal Reminder', 'Traffic Fines Clearance', 'Roadworthy'];

interface Props {
    businesses: BusinessItem[];
    pagination: { count: number; currentPage: number; totalPages: number };
    city: string;
    cityName: string;
}

export default function LicenceRenewalsCityPage({ businesses, pagination, city, cityName }: Props) {
    return (
        <ServiceCategoryPage
            businesses={businesses}
            pagination={pagination}
            city={city}
            cityName={cityName}
            categoryId={CATEGORY_ID}
            categoryLabel={CATEGORY_LABEL}
            categorySlug={CATEGORY_SLUG}
            categoryDescription={CATEGORY_DESCRIPTION}
            tags={TAGS}
        />
    );
}

export const getStaticPaths: GetStaticPaths = makeServiceCategoryPaths();
export const getStaticProps: GetStaticProps = makeServiceCategoryProps(CATEGORY_ID);
